import React, { Component } from 'react';
import loading from '../images/loading.gif';

export class LoadingGraphic extends Component {

  constructor(props) {
    super(props);


  }




  componentDidMount() {
  }


  render() {

    return (
      <div >
             <b>
                در حال بارگذاری 
                </b>
          <img src={loading} style={{ width: "20px",height:"20px" ,margin:"10px" }} alt="" />
        </div>

    );
  }
}


// WEBPACK FOOTER //
// ./src/elements/LoadingGraphic.js